<script setup lang="ts">
import { computed } from 'vue';
import type { VNode } from 'vue';
import { useAuthStore } from '@/store/modules/auth';
import { useRouterPush } from '@/hooks/common/router';
import { useSvgIcon } from '@/hooks/common/icon';
import { fetchCustomBackend, fetchRefleshCache } from '@/service/api';
import {localStg} from "@/utils/storage";

defineOptions({
  name: 'UserAvatar'
});

const authStore: any = useAuthStore();
const { routerPushByKey, toLogin } = useRouterPush();
const { SvgIconVNode } = useSvgIcon();

function loginOrRegister() {
  toLogin();
}

type DropdownKey = 'clear-cache' | 'logout' | 'updatePsw' | 'help' | 'info';

type DropdownOption =
  | {
    key: DropdownKey;
    label: string;
    icon?: () => VNode;
  }
  | {
    type: 'divider';
    key: string;
  };

const options = computed(() => {
  const opts: DropdownOption[] = [
    // {
    //   label: '清除缓存',
    //   key: 'clear-cache',
    //   icon: SvgIconVNode({ icon: 'clarity:refresh-line', fontSize: 18 })
    // },
    {
      label: '操作帮助',
      key: 'help',
      icon: SvgIconVNode({ icon: 'guidance:question-mark', fontSize: 18 })
    },
    {
      type: 'divider',
      key: 'divider'
    },
    {
      label: '个人信息',
      key: 'info',
      icon: SvgIconVNode({ icon: 'ic:sharp-keyboard-command-key', fontSize: 18 })
    },
    {
      type: 'divider',
      key: 'divider'
    },
    {
      label: '修改密码',
      key: 'updatePsw',
      icon: SvgIconVNode({ icon: 'prime:key', fontSize: 18 })
    },
    {
      type: 'divider',
      key: 'divider'
    },
    {
      label: '退出登录',
      key: 'logout',
      icon: SvgIconVNode({ icon: 'ph:sign-out', fontSize: 18 })
    }
  ];

  return opts;
});

function logout() {
  window.$dialog?.info({
    title: '提示',
    content: '确认退出登录吗？',
    positiveText: '确认',
    negativeText: '取消',
    onPositiveClick: () => {
      fetchCustomBackend().then(({ error }) => {
        if (!error) {
         let path =  localStg.get('tenantPath')
          authStore.resetStore(undefined,path);
        }
      })

    }
  });
}

function handleDropdown(key: DropdownKey) {
  if (key === 'logout') {
    logout();
  } else if (key === 'clear-cache') {
    fetchRefleshCache();
  } else if (key === 'help') {
    window.$message?.warning("攻城狮正努力开发中，敬请期待!")
  } else if (key === 'updatePsw') {
    routerPushByKey('personal', { query: { pageType: '6' } });
  } else if (key === 'info') {
    routerPushByKey('personal', { query: { pageType: '5' } });
  } else {
    routerPushByKey(key);
  }
}
</script>

<template>
  <NButton v-if="!authStore.isLogin" quaternary @click="loginOrRegister">
    登录 / 注册
  </NButton>
  <NDropdown v-else placement="bottom" trigger="click" :options="options" @select="handleDropdown">
    <div>
      <ButtonIcon>
        <SvgIcon icon="ph:user-circle" class="text-icon-large" />
        <span class="text-16px font-medium">{{ authStore.userInfo.userName }}</span>
      </ButtonIcon>
    </div>
  </NDropdown>
</template>

<style scoped></style>
